import type { FilledLinkContent } from "@prismicio/types-internal/lib/content"
import { useState } from "react"

import type { ImageBlockData } from "../../../core/imageUtils"
import { FilledLinkField } from "../../LinkField"

type LinkTo = ImageBlockData["linkTo"]

interface ImageLinkControlProps {
  linkTo: LinkTo
  onLinkToChange: (linkTo: LinkTo) => void
}

export function ImageLinkControl(props: ImageLinkControlProps) {
  const { linkTo, onLinkToChange } = props
  const content = useContent(linkTo)

  return (
    <FilledLinkField
      content={content}
      onContentChange={(content) => onLinkToChange(fromContent(content))}
      field={{
        type: "Link",
        config: {
          label: "Link",
          allowTargetBlank: true,
          allowText: false,
        },
      }}
      appearance="condensedButtons"
    />
  )
}

function useContent(linkTo: LinkTo): FilledLinkContent | undefined {
  const [key] = useState(() => crypto.randomUUID())

  if (!linkTo) return undefined
  return {
    __TYPE__: "LinkContent",
    key,
    value: linkTo,
  }
}

function fromContent(content: FilledLinkContent | undefined): LinkTo {
  return content?.value
}
